import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE
} from "../store/types";
import Polyline from '@mapbox/polyline';
import { firebase } from '../config/configureFirebase';
import { FareCalculator } from '../other/FareCalculator';
import { onValue } from "firebase/database";
import store from "../store/store";

// Helpers to map selected cartype to day/night variant
const normalizeBaseName = (name) => {
  if (!name) return '';
  return name.toLowerCase().replace(/\s*nuit\s*/gi, '').trim();
};

const isNightHour = (dateMs) => {
  try {
    const h = new Date(dateMs).getHours();
    return (h >= 19 || h < 6);
  } catch (e) {
    const h = new Date().getHours();
    return (h >= 19 || h < 6);
  }
};

const pickVariant = (cars, selectedName, wantNight) => {
  if (!cars || !selectedName) return null;
  const base = normalizeBaseName(selectedName);
  let day = null;
  let night = null;
  for (let i = 0; i < cars.length; i++) {
    const c = cars[i];
    const cname = c && c.name ? c.name : '';
    if (!cname) continue;
    const nb = normalizeBaseName(cname);
    if (nb === base) {
      if (/nuit/i.test(cname)) night = c; else day = c;
    }
  }
  if (wantNight) return night || day;
  return day || night;
};

export const getEstimate = (bookingData) => async (dispatch) => {
  const   {
      settingsRef
  } = firebase;

  dispatch({
    type: FETCH_ESTIMATE,
    payload: bookingData,
  });
          

  let res = bookingData.routeDetails;

  if(res){
    let points = Polyline.decode(res.polylinePoints);

    let waypoints = points.map((point) => {
        return {
            latitude: point[0],
            longitude: point[1]
        }
    });
    
    onValue(settingsRef, settingdata => {
      let settings = settingdata.val();
      let distance = settings.convert_to_mile? (res.distance_in_km / 1.609344) : res.distance_in_km;
      // Resolve correct car type variant based on trip time if provided
      const cars = store.getState().cartypes.cars;
      const tripTimeMs = bookingData.tripdate ? bookingData.tripdate : Date.now();
      const night = isNightHour(tripTimeMs);
      const resolvedCar = pickVariant(cars, bookingData?.carDetails?.name, night) || bookingData.carDetails;

      let {totalCost, grandTotal, convenience_fees} = FareCalculator(distance, res.time_in_secs, resolvedCar, bookingData.instructionData, settings.decimal);
     
      dispatch({
        type: FETCH_ESTIMATE_SUCCESS,
        payload: {
          pickup:bookingData.pickup,
          drop:bookingData.drop,
          carDetails:resolvedCar,
          instructionData: bookingData.instructionData,
          estimateDistance: parseFloat(parseFloat(distance).toFixed(settings.decimal)),
          fareCost: totalCost ? parseFloat(parseFloat(totalCost).toFixed(settings.decimal)) : 0,
          estimateFare: grandTotal ? parseFloat(parseFloat(grandTotal).toFixed(settings.decimal)) : 0,
          estimateTime:res.time_in_secs,
          convenience_fees: convenience_fees ? parseFloat(parseFloat(convenience_fees).toFixed(settings.decimal)) : 0,
          waypoints: waypoints
        },
      });
    }, {onlyOnce:true});
  }else{
    dispatch({
      type: FETCH_ESTIMATE_FAILED,
      payload: "No Route Found",
    });
  }

}

export const clearEstimate = () => (dispatch) => {
    dispatch({
        type: CLEAR_ESTIMATE,
        payload: null,
    });    
}
